<template>
  <v-flex>
    <v-dialog v-model="showModal" max-width="90%">
      <customer-address add="true" @close="showModal = false"></customer-address>
    </v-dialog>
    <v-dialog v-model="showContact" max-width="90%">
      <contact-modal v-if="showContact" v-on:closeContact="contactClosed" :contact="contact"></contact-modal>
    </v-dialog>

    <v-card>
      <v-card-title>
        <h3>
          <slot></slot>
        </h3>
        <!-- <v-checkbox v-model="checkbox2" label="Use the same address for postal?"></v-checkbox> -->
      </v-card-title>
      <v-layout justify-start row>
        <v-flex>
          <v-radio-group
            v-model="model"
            column
            :error-messages="errors.collect('pMContactPhoneNumber')"
            v-validate="'required'"
          >
            <v-radio
              v-for="(address, index) in addressList"
              :key="index"
              :label="address.formattedAddress"
              :value="address.formattedAddress"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-btn v-on:click="showModal = true" color="primary" large>Add Address</v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>


<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapUtilityActions } = createNamespacedHelpers(
  `orders/utility`
);

export default {
  name: "UtilityAddress",
  inject: {
    $validator: "$validator"
  },
  props: {
    disable: Boolean,
    model: String,
    addressList: Array,
    isAnon: Boolean
  },
  data() {
    return {
      showModal: false,
      showContact: false
    };
  },
  methods: {
    ...mapUtilityActions([
      "addAddress",
      "addAddressAnon",
      "getCustomerAddresses"
    ])
  }
};
</script>

<style>
</style>
